export const backendUrl = process.env.BACKEND_URL;
export const isLocalDevMode = () => process.env.IS_DEVELOPMENT === 'true';
export const isNoAuthMode = () => process.env.IS_NO_AUTH === 'true';

if (isLocalDevMode) {
  // Print info of used environment vars in local dev mode
  console.log(`Used Environment: ${process.env.NODE_ENV}`);
  console.log(`BackendURL: ${backendUrl}`);
  console.log(`IsLocalDevMode: ${isLocalDevMode()}`);
  console.log(`isNoAuthMode: ${isNoAuthMode()}`);
}
